import CameraViewPage from "components/pages/CameraViewPage";

export default function CaptureMabiDepositsCheckFront(props){
    return <CameraViewPage className="capture-styles" />
}